import i18n from '@/i18n';
const convertToHalfsize = (chars) => {
    let halfwidth = '';

    for (let i = 0, l = chars.length; i < l; i++) {
        let charCode = chars[i].charCodeAt(0);

        // Fix full-width dot
        if (charCode === 12290) {
            charCode = 46; // ASCII code for dot
        }

        if (charCode >= 0xff00 && charCode <= 0xffef) {
            charCode = 0xff & (charCode + 0x20);
        }

        halfwidth += String.fromCharCode(charCode);
    }

    return formatNumber(halfwidth);
};

const formatNumber = (number) => {
    return number !== null ? number.toString().replace(/[,]+/g, '') : number;
};

const validMaxLength = (value, numberLength = 255) => {
    let result = true;
    let valueString = value || '';
    if (valueString) {
        if (valueString.length > numberLength) {
            result = false;
        }
    }
    return result;
};

const validCalendarRange = (value) => {
    return !(value[0] === null || value[1] === null);
};

const validCode = (code) => {
    const regex = /^[a-zA-Z0-9_\-\u3040-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF]+$/;
    return regex.test(code);
};

const validEmail = (email) => {
    let re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

const validPostCodeJapan = (value) => {
    let valueText = convertToHalfsize(value);
    return /^\d{3}[-]\d{4}$|^\d{3}[-]\d{2}$|^\d{3}$|^\d{5}$|^\d{7}$/.test(valueText);
};

const validPassword = (password) => {
    let re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,}).{8,32}$/;
    return re.test(password);
};

const validNumber = (number) => {
    let reg = new RegExp('^[0-9]+$');
    return reg.test(number);
};

const validateTextHira = (value) => {
    let re = /^[ぁ-ん ]+$/;
    return re.test(value);
};

const validate = (value, translationKey, type) => {
    let check = true;
    let errorValue = '';
    if (check && type.includes('require')) {
        let valueTrim = value ? String(value).trim() : null;
        if (!valueTrim && value !== 0) {
            errorValue = i18n.t('text.notEmptyInput', { field: i18n.t(translationKey) });
            check = false;
        }
    }
    if (check && type.includes('emptySelect') && (!value || (value && value.length === 0))) {
        errorValue = i18n.t('text.notEmptyChoose', { field: i18n.t(translationKey) });
        check = false;
    }

    if (check && type.includes('calendarRange') && value && !validCalendarRange(value)) {
        errorValue = i18n.t('text.validateCalendarRange', { field: i18n.t(translationKey) });
        check = false;
    }
    if (check && type.includes('max9') && value && !validMaxLength(value, 9)) {
        errorValue = i18n.t('text.max9', { field: i18n.t(translationKey) });
        check = false;
    }
    if (check && type.includes('max50') && value && !validMaxLength(value, 50)) {
        errorValue = i18n.t('text.max50', { field: i18n.t(translationKey) });
        check = false;
    }
    if (check && type.includes('max255') && value && !validMaxLength(value, 255)) {
        errorValue = i18n.t('text.max255', {
            field: i18n.t(translationKey)
        });
        check = false;
    }
    if (check && type.includes('max2000') && value && !validMaxLength(value, 2000)) {
        errorValue = i18n.t('text.max2000', { field: i18n.t(translationKey) });
        check = false;
    }
    if (check && type.includes('validCode') && value && !validCode(value)) {
        errorValue = i18n.t('text.errorCodeFormat');
        check = false;
    }
    if (check && type.includes('validEmail') && value && !validEmail(value)) {
        errorValue = i18n.t('text.errorMailFormat');
        check = false;
    }
    if (check && type.includes('validZipCode') && value && !validPostCodeJapan(value)) {
        errorValue = i18n.t('text.msgPostcodeValid');
        check = false;
    }
    if (check && type.includes('min0Valid') && value && Number(value) <= 0) {
        errorValue = i18n.t('text.min0Valid', { field: i18n.t(translationKey) });
        check = false;
    }
    if (check && type.includes('vaildHiragana') && value && !validateTextHira(value)) {
        errorValue = i18n.t('text.validHiragana');
        check = false;
    }
    return { check: check, errorInfo: errorValue };
};

export default { validEmail, validPassword, validNumber, validate };
